const SUCCESS = 'SUCCESS';
const FAIL = 'FAIL';

export default (action) => ({
  START: `${action}`,
  SUCCESS: `${action}_${SUCCESS}`,
  FAIL: `${action}_${FAIL}`,
});
